export default function Checkmark(props) {
  return (
    <svg width='44.033' height='40' viewBox='0 0 44.033 40' fill='#152a46' {...props}>
      <path d='M20.023,0a19.515,19.515,0,0,0-7.784,1.571A20.083,20.083,0,0,0,1.571,12.216,19.348,19.348,0,0,0,0,19.977a19.465,19.465,0,0,0,1.571,7.808A20.083,20.083,0,0,0,12.239,38.429,19.515,19.515,0,0,0,20.023,40a19.515,19.515,0,0,0,7.784-1.571A20.083,20.083,0,0,0,38.476,27.784a19.465,19.465,0,0,0,1.571-7.808,19.348,19.348,0,0,0-1.571-7.761A20.083,20.083,0,0,0,27.808,1.571,19.515,19.515,0,0,0,20.023,0ZM18.007,28l-7.972-8.019,2.814-2.814,5.205,5.205,9.191-9.238,2.767,2.86ZM44.033,40' />
    </svg>
  )
}
